export const diwali = "/laxmi-golden-jubilee-bonanza";
export const diwaliwinner = "/laxmi-golden-jubilee-bonanza/winners";
export const diwaliabout = "/laxmi-golden-jubilee-bonanza/about";
export const diwaliform = "/laxmi-golden-jubilee-bonanza/enter-your-code";
export const diwaligallery = "/laxmi-golden-jubilee-bonanza/gallery";
export const diwalithankyou = "/laxmi-golden-jubilee-bonanza/thank-you";
export const winners = "/laxmi-golden-jubilee-bonanza/winners";
export const megawinners = "/laxmi-golden-jubilee-bonanza/mega-winners";
export const diwalitermscondition =
  "/laxmi-golden-jubilee-bonanza/terms-and-conditions";
export const termsandconditions = "/terms-and-conditions";

export const diwali2025 = "/khushiyo-ki-diwali-inamo-ki-fuljhadi";
export const diwali2025About = "/khushiyo-ki-diwali-inamo-ki-fuljhadi/about";
export const diwali2025ParticipateForm =
  "/khushiyo-ki-diwali-inamo-ki-fuljhadi/participate";
export const diwali2025Gallery =
  "/khushiyo-ki-diwali-inamo-ki-fuljhadi/gallery";
export const diwaliWinners2025 =
  "/khushiyo-ki-diwali-inamo-ki-fuljhadi/mega-winners";
export const diwali2025Thankyou =
  "/khushiyo-ki-diwali-inamo-ki-fuljhadi/thankyou";
export const diwali2025TermsandCondition =
  "/khushiyo-ki-diwali-inamo-ki-fuljhadi/terms-and-conditions";

// 2026 diwali links
export const diwali2026 = "/dream-big-win-bigger-this-festival";
export const diwali2026ParticipateForm =
  "/dream-big-win-bigger-this-festival/participate";
export const diwali2026Thankyou =
  "/dream-big-win-bigger-this-festival/thankyou";
export const diwali2026About = "/dream-big-win-bigger-this-festival/about";
export const diwali2026Gallery = "/dream-big-win-bigger-this-festival/gallery";
export const diwaliWinners2026 =
  "/dream-big-win-bigger-this-festival/mega-winners";
export const diwaliOfficialRules2026 =
  "/dream-big-win-bigger-this-festival/official-rules";
